import React, {
    useContext,
    useCallback,
    useState,
    useRef,
    useEffect,
} from 'react';

import { CommunityContext } from '../../../context/ContextCreator';
import { getContent as apiGetContent } from '../../../utils/getContent';
import useUser from '../../../utils/useUser';
import { AuthWrapper } from '../AuthWrapper/AuthWrapper';

import ModerationAdmin from './ModerationAdmin/ModerationAdmin';
import ModerationDelete from './ModerationDelete/ModerationDelete';
import ModerationDirectLink from './ModerationDirectLink/ModerationDirectLink';
import ModerationEdit from './ModerationEdit/ModerationEdit';
import ModerationFlag from './ModerationFlag/ModerationFlag';

const ModerationMenu = ({
    hash,
    type,
    handleOnEditClick,
    editboxShowing,
    onMenuClick,
    disableDelete,
    onHandleDelete,
}) => {
    const { user } = useUser();
    /// getcontent function from usecontent name as localgetter

    const { getContent } = useContext(CommunityContext);
    const content = type !== 'editorial-content'
        ? getContent(hash)
        : apiGetContent(type, hash, false);
    const isAdmin = user?.isAdmin;
    const isOwnContent = content.author?.userId === user?.id;
    const contentIsComment = content?.type === 'community-comment';
    let showFlag = (content.flaggingEnabled && !isOwnContent) || false;
    const [menuOpen, setMenuOpen] = useState(false);
    const node = useRef();

    useEffect(() => {
        if (onMenuClick) {
            onMenuClick(menuOpen);
        }
    }, [menuOpen, onMenuClick]);

    if (contentIsComment && !isOwnContent) {
        showFlag = true;
    }
    const showDelete = !!content.deletable && !disableDelete;
    const showEdit = !!content.editable
        && content.type !== 'community-podcast'
        && content.type !== 'editorial-content';

    const getTitle = useCallback(() => {
        switch (content.type) {
        case 'editorial-content':
            return content.article.contentTitle;

        case 'community-podcast':
            return content.podcast.contentTitle;

        case 'community-link':
            return content.link?.previewDescription;

        default:
            return content.title || content.description;
        }
    }, [
        content.article?.contentTitle,
        content.description,
        content.link?.previewDescription,
        content.podcast?.contentTitle,
        content.title,
        content.type,
    ]);

    const authMetrics = {
        login_trigger: 'moderation-menu',
        community_content_key: `${content.type}-${content.hash}`,
        community_on_comment: content.type === 'community-comment',
        fireMultiple: true,
    };

    const handleModMenuClick = (e) => {
        if (node?.current.contains(e.target)) {
            setMenuOpen(true);
            return;
        }
        setMenuOpen(false);
    };
    const closeMenu = () => {
        setMenuOpen(false);
    };
    useEffect(() => {
        document.addEventListener('mousedown', handleModMenuClick);
        return () => {
            document.removeEventListener('mousedown', handleModMenuClick);
        };
    }, []);
    const moderationmenu = `{moderationMenu-${content.hash}}`;
    return (
        <AuthWrapper
            redirectUrl={window?.location?.pathname}
            loginTrigger={moderationmenu}
            customMetric={authMetrics}
        >
            <div className="component-ModerationMenu" ref={node}>
                <style jsx>
                    {`
                        .component-ModerationMenu {
                            width: 30px;
                            height: 30px;
                            position: relative;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }
                        .component-ModerationMenu .moderationMenu-content {
                            display: block;
                            position: absolute;
                            right: 0;
                            top: 30px;
                            z-index: 1;
                            width: 175px;
                            min-height: 60px;
                            padding: 12px 0;
                            box-shadow: 1px 1px 2px 0 #c4c8cc;
                            border: solid 1px #c4c8cc;
                            background-color: #fff;
                            cursor: pointer;
                        }
                        .component-ModerationMenu
                            .moderationMenu-content
                            .moderationMenu-item {
                            text-decoration: none;
                            display: flex;
                            height: 40px;
                            padding: 0 15px;
                            align-items: center;
                        }
                        .component-ModerationMenu
                            .moderationMenu-content
                            .moderationMenu-item
                            .wrap-auth-div {
                            width: 100%;
                        }
                        .component-ModerationMenu
                            .moderationMenu-content
                            .moderationMenu-item:hover {
                            background-color: #f3f5f8;
                            font-weight: 700;
                        }
                    `}
                </style>
                <button
                    aria-label="Edit"
                    type="button"
                    className="moderationMenu-button pt-1 pl-2"
                    onClick={handleModMenuClick}
                />
                {menuOpen ? (
                    <div className="moderationMenu-content">
                        {isAdmin && !contentIsComment ? (
                            <div className="moderationMenu-item">
                                <ModerationDirectLink
                                    url={window.location.pathname}
                                    closeModal={() => setMenuOpen(false)}
                                />
                            </div>
                        ) : null}
                        {showFlag ? (
                            <div className="moderationMenu-item">
                                <ModerationFlag hash={hash} />
                            </div>
                        ) : null}
                        {(showEdit || isOwnContent) && !editboxShowing ? (
                            <div className="moderationMenu-item">
                                <ModerationEdit
                                    hash={hash}
                                    handleOnEditClick={handleOnEditClick}
                                    closeMenu={closeMenu}
                                />
                            </div>
                        ) : null}
                        {showDelete || isOwnContent ? (
                            <div className="moderationMenu-item">
                                <ModerationDelete
                                    hash={hash}
                                    onHandleDelete={onHandleDelete}
                                />
                            </div>
                        ) : null}
                        {isAdmin ? (
                            <div className="moderationMenu-item">
                                <ModerationAdmin
                                    hash={hash}
                                    title={getTitle()}
                                    type={content.type || type}
                                />
                            </div>
                        ) : null}
                    </div>
                ) : null}
            </div>
        </AuthWrapper>
    );
};

ModerationMenu.displayName = 'ModerationMenu';

export default ModerationMenu;
